import { ResourceDetail } from './ResourceDetail'

export type LiveStockInput = {
  daysGrazing: number
  species?: LivestockSpecies
  headcount?: number
}

export interface RDLivestock extends ResourceDetail {
  traitId: 'livestock'
  year: number
  result: boolean
  input: LiveStockInput
}

export const LIVESTOCK_SPECIES = [
  'dairyCattle',
  'beefCattle',
  'mulesAndAsses',
  'goats',
  'hog',
  'horses',
  'sheep',
] as const

export type LivestockSpecies = typeof LIVESTOCK_SPECIES[number]
